// extracted by mini-css-extract-plugin
export default {"reason":"readonly-comment-box-module__reason__L3bAcgL"};